import gql from "graphql-tag";
export const GetProfileDocuments = gql`
  query GetProfileDocuments($AccountId: ID!, $ProfileId: ID!) {
    GetProfileDocuments(ProfileId: $ProfileId, AccountId: $AccountId) {
      FileName
      LastModified
      PreSignedUrl
    }
  }
`;
